module.exports = __webpack_public_path__ + "img/ela.2fe8d00b.svg";